module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_7_m.0540b6d470fa57e6ed72b621ea251e3c.png";